import { createAsyncAction, createAction } from 'typesafe-actions';
import { IdType, ListResult } from '@rootCommon/types/common';
import { Filters } from '@rootCommon/types/filter';
import { User, UserDto, UserListItem } from '@rootCommon/types/user';
import { PermissionTemplateCode } from '@rootCommon/types/permission';

// item
export const fetchUser = createAsyncAction(
  'FETCH_USER_REQUEST',
  'FETCH_USER_SUCCESS',
  'FETCH_USER_FAILURE',
)<IdType, User, Error>();

export const createUser = createAsyncAction(
  'CREATE_USER_REQUEST',
  'CREATE_USER_SUCCESS',
  'CREATE_USER_FAILURE',
)<UserDto, User, Error>();

export const updateUser = createAsyncAction(
  'UPDATE_USER_REQUEST',
  'UPDATE_USER_SUCCESS',
  'UPDATE_USER_FAILURE',
)<{ id: IdType; data: UserDto }, User, Error>();

export const setUserGroupId = createAction('SET_USER_GROUP_ID')<IdType | null>();
export const setUserPermissionCode = createAction('SET_USER_PERMISSION_CODE')<PermissionTemplateCode | null>();

// list
export const fetchUsers = createAsyncAction(
  'FETCH_USERS_REQUEST',
  'FETCH_USERS_SUCCESS',
  'FETCH_USERS_FAILURE',
)<void, ListResult<UserListItem>, Error>();

export const deleteUsers = createAsyncAction(
  'DELETE_USERS_REQUEST',
  'DELETE_USERS_SUCCESS',
  'DELETE_USERS_FAILURE',
)<IdType[], IdType[], Error>();

export const enableUsers = createAsyncAction(
  'ENABLE_USERS_REQUEST',
  'ENABLE_USERS_SUCCESS',
  'ENABLE_USERS_FAILURE',
)<IdType[], IdType[], Error>();

export const lockUsers = createAsyncAction(
  'LOCK_USERS_REQUEST',
  'LOCK_USERS_SUCCESS',
  'LOCK_USERS_FAILURE',
)<IdType[], IdType[], Error>();

export const ungroupUsers = createAsyncAction(
  'UNGROUP_USERS_REQUEST',
  'UNGROUP_USERS_SUCCESS',
  'UNGROUP_USERS_FAILURE',
)<IdType[], IdType[], Error>();

export const groupUsers = createAsyncAction(
  'GROUP_USERS_REQUEST',
  'GROUP_USERS_SUCCESS',
  'GROUP_USERS_FAILURE',
)<{ groupId: IdType; ids: IdType[] }, IdType[], Error>();

export const setUsersFilter = createAction('SET_USERS_FILTER')<Filters>();

export const fetchUsersByGroupId = createAsyncAction(
  'FETCH_USERS_BY_GROUP_ID_REQUEST',
  'FETCH_USERS_BY_GROUP_ID_SUCCESS',
  'FETCH_USERS_BY_GROUP_ID_FAILURE',
)<IdType, { groupId: IdType; data: ListResult<UserListItem> }, Error>();

export const setUsersByGroupIdFilter = createAction('SET_USERS_BY_GROUP_ID_FILTER')<{
  filters: Filters;
  groupId: IdType;
}>();

export const resetUserItemData = createAction('RESET_USER_ITEM_DATA')<void>();
